import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import {
  getIsInitializingSession,
  getIsRecording,
  getIsSummarizing,
} from '~/store/duck/audioRecorder'
import { getAppointmentId } from '~/store/reducers/soap'

import { useAudioRecorderMetadata } from './useAudioRecorderMetadata'
import { useAudioRecorderSession } from './useAudioRecorderSession'

export const useAudioRecorderDisabled = () => {
  const { pathname } = useLocation()
  const appointmentId = useSelector(getAppointmentId)
  const isRecording = useSelector(getIsRecording)
  const isSummarizing = useSelector(getIsSummarizing)
  const isInitializingSession = useSelector(getIsInitializingSession)
  const session = useAudioRecorderSession()
  useAudioRecorderMetadata() // Initialize metadata

  // Always enabled during active recording or summarization
  if (isRecording || isSummarizing) {
    return false
  }

  // Disable if not on SOAP page or missing appointment context
  const isOnSoapPage = pathname.includes('/soap/')
  if (!isOnSoapPage || !appointmentId) {
    return true
  }

  // Disable if session initialization prerequisites aren't met
  const hasValidCorrelationId = Boolean(session.correlationId)
  const shouldSkipInitialization = !hasValidCorrelationId
  // Temporarily disabled - waiting on backend support for medical history
  // || !isMedicalHistoryReady

  if (shouldSkipInitialization || isInitializingSession) {
    return true
  }

  // Enable when all conditions are met
  return false
}
